module.exports = __webpack_public_path__ + "img/certificate3.449b3465.png";